import { useQuery } from '@tanstack/react-query'

import { TANSTACK_QUERY_KEY } from '@/constants/tanstack-query'
import { IHttpError } from '@/data'

import { GetSubscriptionResponse, IUnreadCountResponse, Notification, NotifyModel } from '../models'

const GET_UNREAD_COUNT_KEY = 'GET_UNREAD_COUNT_KEY'

export function useUnreadCount(params: { walletAddresses: string[] }) {
  const enabled = !!(params?.walletAddresses && params.walletAddresses.length > 0)

  return useQuery<IUnreadCountResponse, IHttpError>({
    queryKey: [GET_UNREAD_COUNT_KEY, params.walletAddresses],
    queryFn: async () => {
      return (await Notification.getUnreadCount({ walletAddresses: params.walletAddresses })).data
    },
    enabled,
    refetchInterval: 10000,
  })
}

export function useGetSubscription(referenceId: string, options?: { refetchInterval?: number }) {
  return useQuery<GetSubscriptionResponse, IHttpError>({
    queryKey: [TANSTACK_QUERY_KEY.NOTIFY.GET_SUBSCRIPTION, referenceId],
    queryFn: async () => {
      return (await NotifyModel.getSubscription(referenceId)).data
    },
    enabled: !!referenceId,
    refetchInterval: options?.refetchInterval,
  })
}
